import { useQuery } from "@tanstack/react-query";
import type { PaymentOptionView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";

type UseSellerPaymentOptionsQueryParams = {
  storeSlug: string;
};

export function usePaymentOptionsQuery({
  storeSlug,
}: UseSellerPaymentOptionsQueryParams) {
  const query = useQuery({
    queryKey: queryKeys.seller.paymentOptions(storeSlug),
    queryFn: () => apiJsonClient<PaymentOptionView[]>(endpoints.seller.paymentOptions),
    enabled: storeSlug.length > 0,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
  };
}
